// 导入组件
import Vue from "vue";
import Router from "vue-router";
import { RouterTabRoutes } from "vue-router-tab";

// 解决报错
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
// 针对 push 方法
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch((err) => err);
};
// 针对 replace 方法
Router.prototype.replace = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
	return originalReplace.call(this, location).catch((err) => err);
};
Vue.use(Router);

export default new Router({
	routes: [
		{
			path: "/",
			component: () => import("../views/loginWeb.vue"),
			hidden: true,
			meta: {
				requireAuth: false,
				showNavbar: false
			}
		},
		{
			path: "/login",
			name: "登录",
			component: () => import("../views/loginWeb.vue"),
			hidden: true,
			meta: {
				requireAuth: false,
				showNavbar: false
			}
		},
		{
			path: "/exeIndex",
			name: "首页",
			component: () => import("../views/exeIndex.vue"),
			meta: {
				requireAuth: true,
				title: "首页",
				closable: false,
				notCache: false,
				keepAlive: false,
				showNavbar: true
			},
			hidden: true,
			iconCls: "el-icon-tickets",
			children: [
				{
					path: "/exeIndex/mainIndex",
					name: "工作台",
					component: () => import("../views/mainIndex/mainIndex.vue"),
					meta: {
						requireAuth: true,
						title: "工作台",
						closable: false,
						notCache: false,
						keepAlive: true,
						showNavbar: true,
						icon: "el-icon-house"
					},
					children: [
						...RouterTabRoutes,
						{
							path: "/system/onlineUsers",
							name: "在线用户",
							component: () => import("../views/system/onlineUsers/index.vue"),
							meta: { requireAuth: true, title: "在线用户", closable: true, keepAlive: true, showNavbar: true }
						},
						{
							path: "/system/scheduledTasks",
							name: "定时任务管理",
							component: () => import("../views/system/scheduledTasks/index.vue"),
							meta: { requireAuth: true, title: "定时任务管理", closable: true, keepAlive: false, showNavbar: true }
						},
						{
							path: "/system/serverStatus",
							name: "服务器状态",
							component: () => import("../views/system/serverStatus/index.vue"),
							meta: { requireAuth: true, title: "服务器状态", closable: true, keepAlive: true, showNavbar: true }
						},
						{
							path: "/exeIndex/mainIndex/workbench",
							name: "工作台",
							component: () => import("../views/mainIndex/workbench.vue"),
							meta: {
								requireAuth: true,
								title: "工作台",
								closable: false,
								notCache: false,
								keepAlive: true,
								showNavbar: true,
								icon: "el-icon-house",
								draggable: false
							}
						},
						{
							path: "/401",
							name: "401",
							component: () => import("../views/error/401.vue"),
							meta: {
								requireAuth: true,
								title: "401",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true,
								icon: "el-icon-menu"
							}
						},
						{
							path: "/404",
							name: "404",
							component: () => import("../views/error/404.vue"),
							meta: {
								requireAuth: true,
								title: "404",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true,
								icon: "el-icon-menu"
							}
						},
						{
							path: "/system/uploadVersion",
							name: "系统版本维护",
							component: () => import("../views/system/uploadVersion/index.vue"),
							meta: {
								requireAuth: true,
								title: "系统版本维护",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/dataDictionary",
							name: "数据字典",
							component: () => import("../views/system/dataDictionary/index.vue"),
							meta: {
								requireAuth: true,
								title: "数据字典",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/Module",
							name: "模块管理",
							component: () => import("../views/system/Module/index.vue"),
							meta: {
								requireAuth: true,
								title: "模块管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/Role",
							name: "角色管理",
							component: () => import("../views/system/role/index.vue"),
							meta: {
								requireAuth: true,
								title: "角色管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/message",
							name: "站内信",
							component: () => import("../views/system/message/index.vue"),
							meta: {
								requireAuth: true,
								title: "站内信",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/usageGuide",
							name: "使用说明",
							component: () => import("../views/system/usageGuide/index.vue"),
							meta: {
								requireAuth: true,
								title: "使用说明",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/user",
							name: "人员管理",
							component: () => import("../views/system/user/index.vue"),
							meta: {
								requireAuth: true,
								title: "人员管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/operationLog",
							name: "操作日志",
							component: () => import("../views/system/operationLog/index.vue"),
							meta: {
								requireAuth: true,
								title: "操作日志",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/errorLog",
							name: "错误日志",
							component: () => import("../views/system/errorLog/index.vue"),
							meta: {
								requireAuth: true,
								title: "错误日志",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/loginLog",
							name: "登录日志",
							component: () => import("../views/system/loginLog/index.vue"),
							meta: {
								requireAuth: true,
								title: "登录日志",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/systemNotification",
							name: "系统公告",
							component: () => import("../views/system/systemNotification/index.vue"),
							meta: {
								requireAuth: true,
								title: "系统公告",
								closable: true,
								notCache: false,
								keepAlive: false,
								showNavbar: true
							}
						},
						{
							path: "/system/moduleConfiguration",
							name: "菜单配置",
							component: () => import("../views/system/moduleConfiguration/index.vue"),
							meta: {
								requireAuth: true,
								title: "菜单配置",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/organizationalStructure",
							name: "组织架构",
							component: () => import("../views/system/organizationalStructure/index.vue"),
							meta: {
								requireAuth: true,
								title: "组织架构",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/enumConfig",
							name: "枚举配置",
							component: () => import("../views/system/enumConfig/index.vue"),
							meta: {
								requireAuth: true,
								title: "枚举配置",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/systemBusinessConfiguration",
							name: "系统业务配置",
							component: () => import("../views/system/systemBusinessConfiguration/index.vue"),
							meta: {
								requireAuth: true,
								title: "系统业务配置",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/system/perButtonConfig",
							name: "按钮权限配置",
							component: () => import("../views/system/perButtonConfig/index.vue"),
							meta: {
								requireAuth: true,
								title: "按钮权限配置",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/supply/index",
							name: "供应商管理",
							component: () => import("../views/baseData/supply/index.vue"),
							meta: {
								requireAuth: true,
								title: "供应商管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/goods/index",
							name: "商品管理",
							component: () => import("../views/baseData/goods/index.vue"),
							meta: {
								requireAuth: true,
								title: "商品管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/goods/typeIndex",
							name: "商品类型管理",
							component: () => import("../views/baseData/goods/type/index.vue"),
							meta: {
								requireAuth: true,
								title: "商品类型管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/goods/paramsIndex",
							name: "商品参数管理",
							component: () => import("../views/baseData/goods/params/index.vue"),
							meta: {
								requireAuth: true,
								title: "商品参数管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/customer/index",
							name: "顾客管理",
							component: () => import("../views/baseData/customer/index.vue"),
							meta: {
								requireAuth: true,
								title: "顾客管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/order/index",
							name: "门店订单",
							component: () => import("../views/baseData/storeOrder/order/index.vue"),
							meta: {
								requireAuth: true,
								title: "门店订单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/jgborder/index",
							name: "加工部订单",
							component: () => import("../views/baseData/storeOrder/order/jgbIndex.vue"),
							meta: {
								requireAuth: true,
								title: "加工部订单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/jgbkd/index",
							name: "加工部快递明细",
							component: () => import("../views/baseData/storeOrder/order/jgbkd.vue"),
							meta: {
								requireAuth: true,
								title: "加工部快递明细",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/processOrder/index",
							name: "加工订单",
							component: () => import("../views/baseData/processOrder/order/index.vue"),
							meta: {
								requireAuth: true,
								title: "加工订单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/processOutput/index",
							name: "加工出库单",
							component: () => import("../views/baseData/processOrder/output/index.vue"),
							meta: {
								requireAuth: true,
								title: "加工出库单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/processInput/index",
							name: "加工入库单",
							component: () => import("../views/baseData/processOrder/input/index.vue"),
							meta: {
								requireAuth: true,
								title: "加工入库单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/processWareHouse/index",
							name: "工厂店库存",
							component: () => import("../views/baseData/processOrder/warehouse/index.vue"),
							meta: {
								requireAuth: true,
								title: "工厂店库存",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/processPurchase/index",
							name: "加工采购单",
							component: () => import("../views/baseData/processOrder/purchase/index.vue"),
							meta: {
								requireAuth: true,
								title: "加工采购单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/orderstatistics/index",
							name: "订单统计",
							component: () => import("../views/baseData/storeOrder/order/statistic/orderStatistic.vue"),
							meta: {
								requireAuth: true,
								title: "订单统计",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/orderStatistic/day",
							name: "日订单统计",
							component: () => import("../views/baseData/storeOrder/order/statistic/storeDayStatistic.vue"),
							meta: {
								requireAuth: true,
								title: "日订单统计",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/orderStatistic/jgbKD",
							name: "加工部快递统计",
							component: () => import("../views/baseData/storeOrder/order/statistic/jgbKDStatistic.vue"),
							meta: {
								requireAuth: true,
								title: "加工部快递统计",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/afterSalesStatistic/index",
							name: "售后统计",
							component: () => import("../views/baseData/storeOrder/order/statistic/afterSalesStatistic.vue"),
							meta: {
								requireAuth: true,
								title: "售后统计",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/warehouse/index",
							name: "实时库存",
							component: () => import("../views/baseData/storeOrder/warehouse/index.vue"),
							meta: {
								requireAuth: true,
								title: "实时库存",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/inputStore/index",
							name: "入库单",
							component: () => import("../views/baseData/receipt/inputStore/index.vue"),
							meta: {
								requireAuth: true,
								title: "入库单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/inputStoreDtl/index",
							name: "入库明细",
							component: () => import("../views/baseData/receipt/inputStoreDtl/index.vue"),
							meta: {
								requireAuth: true,
								title: "入库明细",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/outputStore/index",
							name: "出库单",
							component: () => import("../views/baseData/receipt/outputStore/index.vue"),
							meta: {
								requireAuth: true,
								title: "出库单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/outputStoreDtl/index",
							name: "出库明细管理",
							component: () => import("../views/baseData/receipt/outputStoreDtl/index.vue"),
							meta: {
								requireAuth: true,
								title: "出库明细",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/purchaseOrder/index",
							name: "采购单管理",
							component: () => import("../views/baseData/purchaseOrder/index.vue"),
							meta: {
								requireAuth: true,
								title: "采购单管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/storeCost/index",
							name: "备用金管理",
							component: () => import("../views/accounting/storeCost/main/main.vue"),
							meta: {
								requireAuth: true,
								title: "备用金管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/storeCost/dtl",
							name: "备用金明细",
							component: () => import("../views/accounting/storeCost/dtl/dtlMain.vue"),
							meta: {
								requireAuth: true,
								title: "备用金明细",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/storeCost/appropriation",
							name: "备用金下拨",
							component: () => import("../views/accounting/storeCost/appropriation/main.vue"),
							meta: {
								requireAuth: true,
								title: "备用金下拨",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/storeCost/statistic/store",
							name: "备用金统计",
							component: () => import("../views/accounting/storeCost/statistic/statisticStore.vue"),
							meta: {
								requireAuth: true,
								title: "备用金统计",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/storeCost/expense",
							name: "门店开销",
							component: () => import("../views/accounting/storeCost/expense/main.vue"),
							meta: {
								requireAuth: true,
								title: "门店开销",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/commission/main",
							name: "提成记录",
							component: () => import("../views/accounting/storeCost/commission/main.vue"),
							meta: {
								requireAuth: true,
								title: "提成记录",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/attendance/index",
							name: "考勤记录",
							component: () => import("../views/accounting/attendance/main.vue"),
							meta: {
								requireAuth: true,
								title: "考勤记录",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/attendance/card",
							name: "考勤打卡",
							component: () => import("../views/accounting/attendance/card.vue"),
							meta: {
								requireAuth: true,
								title: "考勤打卡",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/attendance/statistic",
							name: "考勤统计",
							component: () => import("../views/accounting/attendance/statistic.vue"),
							meta: {
								requireAuth: true,
								title: "考勤统计",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/pay/record",
							name: "收款记录",
							component: () => import("../views/pay/main.vue"),
							meta: {
								requireAuth: true,
								title: "收款记录",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/pay/statistic",
							name: "收款统计",
							component: () => import("../views/pay/statistic.vue"),
							meta: {
								requireAuth: true,
								title: "收款统计",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/pay/amountStatistic",
							name: "收款统计",
							component: () => import("../views/pay/statisticIndex.vue"),
							meta: {
								requireAuth: true,
								title: "收款统计",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/pay/problem",
							name: "收款问题记录",
							component: () => import("../views/pay/problemRecord.vue"),
							meta: {
								requireAuth: true,
								title: "收款问题记录",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/vip/manage",
							name: "会员管理",
							component: () => import("../views/vip/manage/main.vue"),
							meta: {
								requireAuth: true,
								title: "会员管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/vip/rechargeHistory",
							name: "会员充值",
							component: () => import("../views/vip/recharge/main.vue"),
							meta: {
								requireAuth: true,
								title: "会员充值",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/vip/returnMoney",
							name: "会员退款",
							component: () => import("../views/vip/returnMoney.vue"),
							meta: {
								requireAuth: true,
								title: "会员退款",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/reimbursement/index",
							name: "报销单",
							component: () => import("../views/accounting/reimbursement/main.vue"),
							meta: {
								requireAuth: true,
								title: "报销单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/baseSalary/index",
							name: "基本工资",
							component: () => import("../views/accounting/salary/baseSalary/main.vue"),
							meta: {
								requireAuth: true,
								title: "基本工资",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/monthSalary/index",
							name: "月工资",
							component: () => import("../views/accounting/salary/monthSalary/main.vue"),
							meta: {
								requireAuth: true,
								title: "月工资",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/productType/index",
							name: "商品类型",
							component: () => import("../views/product/type/main.vue"),
							meta: {
								requireAuth: true,
								title: "商品类型",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/storeProduct/index",
							name: "门店库存",
							component: () => import("../views/product/store/main.vue"),
							meta: {
								requireAuth: true,
								title: "门店库存",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/productInput/index",
							name: "入库记录",
							component: () => import("../views/product/input/main.vue"),
							meta: {
								requireAuth: true,
								title: "入库记录",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/productSales/index",
							name: "商品销售",
							component: () => import("../views/product/sales/main.vue"),
							meta: {
								requireAuth: true,
								title: "商品销售",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/storeCheck/index",
							name: "库存盘点",
							component: () => import("../views/product/storeCheck/index.vue"),
							meta: {
								requireAuth: true,
								title: "库存盘点",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/salesOrder/index",
							name: "销售订单",
							component: () => import("../views/product/sales/index.vue"),
							meta: {
								requireAuth: true,
								title: "销售订单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/salesOrderDtl/main",
							name: "销售订单明细",
							component: () => import("../views/product/sales/dtlMain.vue"),
							meta: {
								requireAuth: true,
								title: "销售订单明细",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/sales/statistic",
							name: "销售统计",
							component: () => import("../views/product/sales/statistic.vue"),
							meta: {
								requireAuth: true,
								title: "销售统计",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/transfer/main",
							name: "调拨记录",
							component: () => import("../views/product/transfer/main.vue"),
							meta: {
								requireAuth: true,
								title: "调拨记录",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/transfer/dtl",
							name: "调拨商品明细",
							component: () => import("../views/product/transfer/dtl.vue"),
							meta: {
								requireAuth: true,
								title: "调拨商品明细",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/storeDayReport/index",
							name: "门店日报表",
							component: () => import("../views/accounting/report/storeDayReport.vue"),
							meta: {
								requireAuth: true,
								title: "门店日报表",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/storeProfit/index",
							name: "门店利润",
							component: () => import("../views/accounting/storeCost/profit/storeProfit.vue"),
							meta: {
								requireAuth: true,
								title: "门店利润",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/storeSubscription/index",
							name: "门店申购单",
							component: () => import("../views/product/subscription/storeSubscription.vue"),
							meta: {
								requireAuth: true,
								title: "门店申购单",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/subscription/index",
							name: "申购单管理",
							component: () => import("../views/product/subscription/subscriptionManage.vue"),
							meta: {
								requireAuth: true,
								title: "申购单管理",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/subscriptionDtl/main",
							name: "申购单明细",
							component: () => import("../views/product/subscriptionDtl/main.vue"),
							meta: {
								requireAuth: true,
								title: "申购单明细",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						},
						{
							path: "/subscriptionReturn/main",
							name: "退货明细",
							component: () => import("../views/product/subscriptionReturn/main.vue"),
							meta: {
								requireAuth: true,
								title: "退货明细",
								closable: true,
								notCache: false,
								keepAlive: true,
								showNavbar: true
							}
						}
					]
				}
			]
		}
	]
});
